import size from 'lodash/size';
import qs from 'query-string';

import { HealthProfileUpdateStepNames } from '../components/Pages/HealthProfileUpdate/constants';

import {
  AccountPageAddAddress,
  AccountPageInsurance,
  orderTracking,
  medications,
  loggedInTransferRx,
  accountPage,
  loggedInHealthProfile,
  shop,
} from './paths';

// accepts any number of strings which represent the URL query
// parameters that you would like preserved during a redirect
export function setPreservedQueryParameters(...paramsToPreserve: string[]): string {
  const parsed = qs.parse(window.location.search);
  const accumulator: { [key: string]: string | (string | null)[] | null } = {};

  for (let i = 0; i < paramsToPreserve.length; i++) {
    if (parsed[paramsToPreserve[i]]) {
      accumulator[paramsToPreserve[i]] = parsed[paramsToPreserve[i]];
    }
  }

  // if there were matching parameters found stringify and return them
  return size(accumulator) > 0 ? `?${qs.stringify(accumulator)}` : '';
}

export const getUrlQueryStrings = (queryStrings: string[]): any => {
  const searchParams = new URLSearchParams(window.location.search);
  const foundQueryStrings = queryStrings.reduce((resultObj: { [key: string]: string | null }, queryString) => {
    resultObj[queryString] = searchParams.get(queryString);
    return resultObj;
  }, {});
  return foundQueryStrings;
};

export const getLoginRedirectPath = (queryString: string): string => {
  const { flow, ...remainderQs } = qs.parse(queryString);
  const REDIRECT_FLOWS = {
    uploadInsurance: 'uploadInsurance',
    orderTracking: 'orderTracking',
    createAddress: 'createAddress',
    deliveryAddresses: 'deliveryAddresses',
    transferPharmacy: 'transferPharmacy',
    healthProfile: 'healthProfile',
    essentialsShop: 'essentialsShop',
  };

  if (flow === REDIRECT_FLOWS.uploadInsurance) {
    // If flow QS is set to uploadInsurance, show upload insurance.
    console.log('Redirecting to upload insurance.');
    return AccountPageInsurance.route;
  } else if (flow === REDIRECT_FLOWS.orderTracking) {
    // If flow QS is set to orderTracking, show order tracking.
    console.log('Redirecting to order tracking.');
    const orderUuid = remainderQs.orderUuid ? (remainderQs.orderUuid as string) : '';
    return orderTracking.toPath({ orderId: orderUuid });
  } else if (flow === REDIRECT_FLOWS.createAddress) {
    // If flow QS is set to createAddress, create address form.
    console.log('Redirecting to create address form.');
    return AccountPageAddAddress.route;
  } else if (flow === REDIRECT_FLOWS.deliveryAddresses) {
    // If flow QS is set to createAddress, create address form.
    console.log('Redirecting to account page address section.');
    return `${accountPage.route}#deliveryAddresses`;
  } else if (flow === REDIRECT_FLOWS.transferPharmacy) {
    // If flow QS is set to transferPharmacy, show logged-in transfer pharmacy flow.
    console.log('Redirecting to transfer pharmacy.');
    return loggedInTransferRx.toPath({ step: 'medications' });
  } else if (flow === REDIRECT_FLOWS.healthProfile) {
    console.log('Redirecting to health profile flow.');
    /*
     TODO: Hardcoding to SMS source here since it's the only type of magic link
     we're sending for the Health Profile form. Update if we start sending email
     */
    return `${loggedInHealthProfile.toPath({
      stepName: HealthProfileUpdateStepNames.SelectTakingMedications,
    })}?source=sms`;
  } else if (flow === REDIRECT_FLOWS.essentialsShop) {
    console.log('Redirecting to essentials shop.');
    return shop.route;
  } else {
    console.log('Redirecting to medications.');
    return medications.route;
  }
};
